exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-Modal-___style__container___3H5k1 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-color: rgba(71, 71, 71, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  z-index: 1000; }\n\n.src-components-Modal-___style__content___1ULzZ {\n  background-color: #fff;\n  width: 92%;\n  max-width: 560px;\n  border-radius: 3px; }\n  .src-components-Modal-___style__content___1ULzZ.src-components-Modal-___style__large___23iGy {\n    max-width: 1200px; }\n\n.src-components-Modal-___style__header___3y-uj {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  padding: 20px 30px;\n  font-size: 18px; }\n  .src-components-Modal-___style__header___3y-uj .src-components-Modal-___style__close___2vYpU {\n    cursor: pointer; }\n\n.src-components-Modal-___style__main___3AJ6s {\n  position: relative;\n  min-height: 100%;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"container": "src-components-Modal-___style__container___3H5k1",
	"content": "src-components-Modal-___style__content___1ULzZ",
	"large": "src-components-Modal-___style__large___23iGy",
	"header": "src-components-Modal-___style__header___3y-uj",
	"close": "src-components-Modal-___style__close___2vYpU",
	"main": "src-components-Modal-___style__main___3AJ6s"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/components/Modal/style.scss
// module id = 397
// module chunks = 0